'use strict';

const collectionFactory = require('./collection.factory');

const insuranceCatalogueCollection = collectionFactory({
    dataUrl: 'getinsurancecatalogue',

    loadedTrigger: 'productCatalogueCollectionIsOk',

    getInsurances() {
        if (Odigeo._.isEmpty(this.processedCollection)) {
            this.processData();
        }

        return this.processedCollection;
    },

    getInsurance(id) {
        return Odigeo._.find(this.getInsurances(), (insurance) => {
            return insurance.id === id;
        });
    },

    getInsuranceByPolicy(policy) {
        return Odigeo._.find(this.getInsurances(), {policy: policy}) || {};
    },

    processData() {
        const {insurances, preselected} = this.toJSON();

        this.processedCollection = Odigeo._.map(insurances, (insurance) => {
            return Odigeo._.extend(insurance, {
                preselected: Odigeo._.contains(preselected, insurance.policy),
            });
        });
    },

    filterPreselected(policyToFilter) {
        this.set('preselected', Odigeo._.filter(this.getPreselected(), (policy) => policy !== policyToFilter));
    },

    isCancellationFree() {
        return this.get('cancellationFree');
    },

    isCancellationFreeCandidate() {
        return this.get('cancellationFreeCandidate');
    },

    isRefundableFareUpgradeShowInPax() {
        return Odigeo.Utils.parseJson(Odigeo.Session.get('isRefundableFareUpgradeShowInPax')) || false;
    },

    isRefundableFareUpgradeSetInPax() {
        return Odigeo.Utils.parseJson(Odigeo.Session.get('isRefundableFareUpgradeSetInPax')) || false;
    },

    getPreselected() {
        return this.get('preselected') || [];
    },

    isAnyInsurancesInCart() {
        return this.get('anyInsurancesInCart') || this.getPreselected().length > 0;
    },

    postFetch() {
        this.processData();
    },
});

module.exports.getInstance = insuranceCatalogueCollection.getInstance;
